export default __webpack_public_path__ + "static/media/fa-duotone-900.0d8b5ecc.ttf";